<template lang="pug">
  div#custom-content(v-if="contentVisible")
    // Correct Answer, Score
    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap; align-items: baseline;") 
        div(style="flex-grow: 1;")
          math-quill-view#subtext(
            v-if="questionData.allow_math_equivs"
              :value="questionData.lefthand"
              style="padding-right: 10px;"
            )
          div#subtext(
            v-else
            class="mq-math-mode"
          ) {{ questionData.lefthand }}
          custom-point-badge(:value="questionData.score")
            math-quill-view#answer-box(
              v-if="questionData.allow_math_equivs"
              :value="questionData.correct_answer"
            )
            div#answer-box(
              v-else
            ) {{ questionData.correct_answer }}
          math-quill-view#subtext(
            v-if="questionData.allow_math_equivs"
            :value="questionData.righthand"
            style="padding-left: 10px;"
          )
          div#subtext(
            v-else
            class="mq-math-mode"
          ) {{ questionData.righthand }}

        // Custom Symbols
        div(v-if="questionSymbols.length >= 1 && questionData.allow_math_equivs"
          class="preview-customsymbols" style="flex-grow: 1;")
            label#sublabel Custom Symbols:
            span(v-for="sym, symIndex in questionSymbols")
              math-quill-view(
                :value="sym"
                style="font-size: 16px; margin-left: 5px;")
              span(v-if="symIndex < questionSymbols.length-1") ,
</template>

<script>
  import MathQuillView from '@/components/utils/MathQuillView'
  import CustomPointBadge from '@/components/instructor/Question/Components/CustomPointBadge'

  export default {
    name: 'AnswerInputPreview',

    components: {
      MathQuillView,
      CustomPointBadge,
    },     

    props: {
      questionData: {
        type: Object,
        required: true,
      },

      contentVisible: {
        type: Boolean,
        required: true,
      },
    },

    computed: {
      questionSymbols() {
        let symbolsList = this.questionData.custom_symbols.toString().replace(/['"]+/g, '')
          if ( symbolsList != '' ) {
             return symbolsList.split(',')
          }
          return []
      },
    },
  }
</script>

<style module>
  #sublabel {
    font-size: 12px;
    font-style: italic;
  }

  #subtext {
    font-size: 16px;
    margin-left: 5px;
  }

  #answer-box {
    font-size: 1.5em;
    padding: 8px 15px 8px 15px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    min-width: 100px;
    text-align: center;
  }

</style>
